(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cdm-halloween-bats"]) return;
  try {
    
  // Un único componente, también al volver a cargar la sección en el editor.
  if (!customElements.get('cdm-halloween')) {
    customElements.define('cdm-halloween', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 749px)');
        this.bats = [];
        this.frame = 0;
        this.deadline = 0;
        const options = { signal: this.controller.signal };
        this.motion.addEventListener('change', () => this.setup(), options);
        this.mobile.addEventListener('change', () => this.setup(), options);
        window.addEventListener('scroll', () => this.fly(), { ...options, passive: true });
        window.addEventListener('resize', () => this.fly(), options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            cancelAnimationFrame(this.frame);
            this.frame = 0;
          } else {
            this.fly();
          }
        }, options);
        document.addEventListener('click', event => {
          if (event.target instanceof Element && event.target.closest('a[href]')) this.fly();
        }, options);
        this.setup();
      }

      disconnectedCallback() {
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.replaceChildren();
      }

      setup() {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.replaceChildren();
        this.bats = [];
        if (this.dataset.enabled !== 'true' || this.motion.matches) return;
        const count = Math.min(12, Math.max(0, Number(
          this.mobile.matches ? this.dataset.mobile : this.dataset.count
        ) || 0));
        const size = Math.min(64, Math.max(24, Number(this.dataset.size) || 38));
        for (let i = 0; i < count; i++) {
          const el = document.createElement('span');
          el.className = 'cdm-bat cdm-flying';
          el.style.width = size + 'px';
          el.style.height = size * .55 + 'px';
          // Silueta propia: cuerpo, orejas y alas con borde festoneado.
          el.innerHTML = '<svg viewBox="0 0 100 55" fill="currentColor" focusable="false" aria-hidden="true"><g class="cdm-wing"><path d="M48 24 Q28 3 2 6 Q10 17 7 31 Q19 21 25 36 Q35 27 47 39Z"/><path d="M52 24 Q72 3 98 6 Q90 17 93 31 Q81 21 75 36 Q65 27 53 39Z"/></g><path d="M43 25 L42 10 L49 16 L53 16 L60 10 L58 27 Q65 46 51 51 Q36 45 43 25Z"/><circle cx="47" cy="26" r="1.2" fill="#c9b9de"/><circle cx="55" cy="26" r="1.2" fill="#c9b9de"/></svg>';
          el.querySelector('.cdm-wing').style.animationDelay = (-i * .13) + 's';
          this.append(el);
          this.bats.push({ el, size, x: Math.random() * Math.max(1, innerWidth-size),
            y: 40 + Math.random() * Math.max(1, innerHeight-120), phase: i * 2,
            anchor: null, target: null });
        }
        this.fly();
      }

      fly() {
        if (!this.bats.length || document.hidden) return;
        this.deadline = performance.now() + 700;
        for (const bat of this.bats) {
          bat.anchor = null;
          bat.target = null;
          bat.el.className = 'cdm-bat cdm-flying';
        }
        if (!this.frame) this.frame = requestAnimationFrame(t => this.tick(t));
      }

      choosePerches() {
        // Buscar bordes visibles fuera de cabeceras, menús y ventanas emergentes.
        const nodes = document.querySelectorAll('main img, main button, main .button, #MainContent img, #MainContent .button');
        const candidates = [];
        for (const node of nodes) {
          if (candidates.length >= 60) break;
          if (node.closest('dialog, [role="dialog"], [inert], [aria-hidden="true"]')) continue;
          const r = node.getBoundingClientRect();
          if (r.width < 60 || r.height < 25 || r.top < 85 || r.top > innerHeight-50 ||
              r.left < 0 || r.right > innerWidth || getComputedStyle(node).visibility === 'hidden') continue;
          const probe = document.elementFromPoint(r.left + r.width/2, r.top + 4);
          if (!probe || !(node === probe || node.contains(probe) || probe.contains(node))) continue;
          candidates.push(node);
        }
        this.bats.forEach((bat, i) => {
          bat.anchor = candidates.length ? candidates.splice(Math.floor(Math.random()*candidates.length), 1)[0] : null;
          bat.target = { x: i % 2 ? innerWidth-bat.size-10 : 10,
            y: Math.min(innerHeight-60, 100+i*55) };
        });
      }

      destination(bat) {
        if (bat.anchor?.isConnected) {
          const r = bat.anchor.getBoundingClientRect();
          if (r.top >= 65 && r.top <= innerHeight-30 && r.width > 0) {
            return { x: Math.min(innerWidth-bat.size-8, Math.max(8, r.right-bat.size)),
              y: Math.max(8, r.top-bat.size*.49) };
          }
        }
        return bat.target;
      }

      tick(now) {
        this.frame = 0;
        if (!this.isConnected || document.hidden) return;
        const dt = Math.min(40, this.last ? now-this.last : 16);
        this.last = now;
        const flying = now < this.deadline;
        if (!flying && this.bats.some(b => !b.target)) this.choosePerches();
        let moving = flying;
        for (const bat of this.bats) {
          const dest = flying ? {
            x: 12 + (Math.sin(now/2100+bat.phase)+1)*.5*Math.max(0, innerWidth-bat.size-24),
            y: 85 + (Math.cos(now/2600+bat.phase)+1)*.5*Math.max(0, innerHeight-170)
          } : this.destination(bat);
          const dx = dest.x-bat.x, dy = dest.y-bat.y;
          const distance = Math.hypot(dx,dy);
          const step = Math.min(distance, dt * (flying ? .12 : .22));
          if (distance > .6) {
            bat.x += dx/distance*step;
            bat.y += dy/distance*step;
            moving = true;
          } else if (!flying) {
            bat.x = dest.x;
            bat.y = dest.y;
            bat.el.className = 'cdm-bat cdm-resting';
          }
          bat.el.style.transform = 'translate3d('+bat.x.toFixed(2)+'px,'+bat.y.toFixed(2)+'px,0)';
        }
        if (moving) this.frame = requestAnimationFrame(t => this.tick(t));
        else this.last = 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
